import { defineDocument } from '../../schema';
export const featureLoonsDocument = defineDocument({
    id: 'feature:loons',
    kind: 'feature',
    slug: 'loons',
    route: '/discover/features/loons',
    seo: {
        title: 'Discover Loons',
        description: 'Loons are the game credits hosts use to start Airhead Games. Players join free. No commitments or subscriptions. Set up Rapid Reload for one-click purchases.',
    },
    hero: {
        eyebrow: [
            {
                type: 'text',
                text: 'Discover Feature',
            },
        ],
        title: [
            {
                type: 'text',
                text: 'Loons',
            },
        ],
        description: [
            {
                type: 'text',
                text: 'Loons are the game credits hosts use to start Airhead Games. Players join free. No commitments or subscriptions. Set up Rapid Reload for one-click purchases.',
            },
        ],
    },
    aside: {
        showToc: true,
    },
    sections: [
        {
            id: 'overview',
            title: [
                {
                    type: 'text',
                    text: 'What Are Loons?',
                },
            ],
            blocks: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'Loons are the game credits used to host Airhead Games. They are sold in packs so you can buy what you need, when you need it. Browse available Loon packs on the ',
                        },
                        {
                            type: 'link',
                            href: '/pricing',
                            children: [
                                {
                                    type: 'text',
                                    text: 'Pricing',
                                },
                            ],
                        },
                        {
                            type: 'text',
                            text: ' page.',
                        },
                    ],
                },
                {
                    type: 'image',
                    imageAsset: 'loonSVG',
                    imageAlt: 'One Loon - In Poppy We Trust.',
                    maxWidth: 400,
                    caption: [
                        {
                            type: 'text',
                            text: 'One Loon - In Poppy We Trust.',
                        },
                    ],
                },
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'Loons are exclusive to our platform, have no cash value, and are not transferable or exchangeable. New accounts receive free Loons to start playing right away. When you are ready for more, top up your balance to keep the party going.',
                        },
                    ],
                },
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'You can also earn Loons through ',
                        },
                        {
                            type: 'link',
                            href: '/discover/features/achievements',
                            children: [
                                {
                                    type: 'text',
                                    text: 'Achievements',
                                },
                            ],
                        },
                        {
                            type: 'text',
                            text: ', for example by hosting games and connecting your Twitch account.',
                        },
                    ],
                },
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'Only the host needs Loons to get a game started. Players always join for free. Each game has a fixed Loon price and lasts 10 to 20 minutes, which helps keep costs predictable.',
                        },
                    ],
                },
            ],
        },
        {
            id: 'purchase-experience',
            title: [
                {
                    type: 'text',
                    text: 'Buying Loons',
                },
            ],
            blocks: [],
            sections: [
                {
                    id: 'purchase-experience__initiating-a-purchase',
                    title: [
                        {
                            type: 'text',
                            text: 'Initiating a Purchase',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'You must be logged in to purchase Loons. Buying is only available from the ',
                                },
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Loons menu',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' at the top of the sidebar in the ',
                                },
                                {
                                    type: 'link',
                                    href: '/library',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Game Library',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: '. If you are not signed in, the menu does not appear.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Open the menu by clicking your Loon balance, then choose ',
                                },
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Buy Loons',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' to start a purchase.',
                                },
                            ],
                        },
                        {
                            type: 'image',
                            imageAsset: 'loonsMenu',
                            imageAlt: 'Loons menu at the top of the Game Library sidebar, showing balance and Buy Loons.',
                            caption: [
                                {
                                    type: 'text',
                                    text: 'Loons menu at the top of the Game Library sidebar, showing balance and Buy Loons.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'If you already have a saved payment method in Stripe, the button reads ',
                                },
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Buy',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' and we try to charge that method without leaving the Game Library. If you do not, the button reads ',
                                },
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Checkout',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: " and you finish the purchase on Stripe's secure checkout page. If a saved-method charge cannot be completed, you may be redirected to Stripe to finish the purchase.",
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'purchase-experience__rapid-reload',
                    title: [
                        {
                            type: 'text',
                            text: 'Rapid Reload',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Rapid Reload is the fastest way to buy Loons. It skips the pack picker, so instead of choosing a pack each time, ',
                                },
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Buy Loons',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' opens a confirmation to charge your saved payment method for your preferred pack. It is especially helpful for hosts who do not want game sessions interrupted by checkout.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'You need a saved payment method in Stripe and a preferred Loon pack selected. Set both up from ',
                                },
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Manage Rapid Reload',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' in the Loons menu.',
                                },
                            ],
                        },
                        {
                            type: 'image',
                            imageAsset: 'loonsRapidReload',
                            maxWidth: 400,
                            imageAlt: 'Manage Rapid Reload dialog showing payment method status and preferred pack selector.',
                            caption: [
                                {
                                    type: 'text',
                                    text: 'Manage Rapid Reload dialog showing payment method status and preferred pack selector.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'To set up or change Rapid Reload:',
                                },
                            ],
                        },
                        {
                            type: 'list',
                            ordered: true,
                            items: [
                                [
                                    {
                                        type: 'text',
                                        text: 'Open ',
                                    },
                                    {
                                        type: 'link',
                                        href: '/library?dialog=rapid-reload',
                                        children: [
                                            {
                                                type: 'text',
                                                text: 'Manage Rapid Reload',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: " from the Loons menu in the Game Library's sidebar.",
                                    },
                                ],
                                [
                                    {
                                        type: 'text',
                                        text: 'If your payment method is not saved in Stripe, use ',
                                    },
                                    {
                                        type: 'strong',
                                        children: [
                                            {
                                                type: 'text',
                                                text: 'Manage in Stripe',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: ' in the dialog to add one, then return.',
                                    },
                                ],
                                [
                                    {
                                        type: 'text',
                                        text: 'Under Preferred Loon Pack, pick the pack size you want for one-click top-ups, or ',
                                    },
                                    {
                                        type: 'strong',
                                        children: [
                                            {
                                                type: 'text',
                                                text: 'None',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: ' to turn Rapid Reload off.',
                                    },
                                ],
                                [
                                    {
                                        type: 'text',
                                        text: 'Click ',
                                    },
                                    {
                                        type: 'strong',
                                        children: [
                                            {
                                                type: 'text',
                                                text: 'Confirm',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: ' to save.',
                                    },
                                ],
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'When Rapid Reload is active, buying Loons goes straight to confirmation. To disable Rapid Reload or change your preferred pack, reopen the Loons menu. To update your saved payment method, visit the Stripe customer portal from the same menu.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'purchase-experience__accepted-payment-methods',
                    title: [
                        {
                            type: 'text',
                            text: 'Accepted Payment Methods',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'All purchases are processed through Stripe, a trusted global payment processor. Airhead Games never collects or stores your payment information directly. Accepted payment methods include:',
                                },
                            ],
                        },
                        {
                            type: 'list',
                            items: [
                                [
                                    {
                                        type: 'text',
                                        text: 'Credit and debit cards',
                                    },
                                ],
                                [
                                    {
                                        type: 'text',
                                        text: 'Apple, Google, and Cash App Pay',
                                    },
                                ],
                                [
                                    {
                                        type: 'text',
                                        text: 'Link',
                                    },
                                ],
                                [
                                    {
                                        type: 'text',
                                        text: 'Crypto/Stablecoins',
                                    },
                                ],
                                [
                                    {
                                        type: 'text',
                                        text: 'Bancontact, EPS, and iDEAL',
                                    },
                                ],
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Availability of certain payment methods depends on your country and browser. For full details on purchases, refunds, and credits, see ',
                                },
                                {
                                    type: 'link',
                                    href: '/terms',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Terms & Conditions',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: '.',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'using-loons',
            title: [
                {
                    type: 'text',
                    text: 'Using Loons',
                },
            ],
            blocks: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'Loons are deducted from your balance when you press "Start Game" in a room. Each game has a fixed Loon price communicated before you select it, so there are no surprises. If you do not have enough Loons to start the game, you won\'t be able to select it. Top up your balance to continue.',
                        },
                    ],
                },
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'Players never need Loons; joining a room is always free. Only the host needs a Loon balance to get things started. For more on how games start, see ',
                        },
                        {
                            type: 'link',
                            href: '/discover/features/game-room-lifecycle#starting-a-game',
                            children: [
                                {
                                    type: 'text',
                                    text: 'Game Room Lifecycle',
                                },
                            ],
                        },
                        {
                            type: 'text',
                            text: '.',
                        },
                    ],
                },
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'Your Loon balance never expires. Any Loons you buy will be there whenever you are ready to host next.',
                        },
                    ],
                },
            ],
        },
        {
            id: 'loon-settings',
            title: [
                {
                    type: 'text',
                    text: 'Managing Your Loons',
                },
            ],
            blocks: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'The ',
                        },
                        {
                            type: 'strong',
                            children: [
                                {
                                    type: 'text',
                                    text: 'Loons menu',
                                },
                            ],
                        },
                        {
                            type: 'text',
                            text: ' at the top of the ',
                        },
                        {
                            type: 'link',
                            href: '/library',
                            children: [
                                {
                                    type: 'text',
                                    text: 'Game Library',
                                },
                            ],
                        },
                        {
                            type: 'text',
                            text: ' sidebar is your hub when you are logged in. Your balance is always visible on the menu trigger. From the menu you can:',
                        },
                    ],
                },
                {
                    type: 'list',
                    items: [
                        [
                            {
                                type: 'text',
                                text: 'Buy Loons.',
                            },
                        ],
                        [
                            {
                                type: 'text',
                                text: 'Manage Rapid Reload.',
                            },
                        ],
                        [
                            {
                                type: 'text',
                                text: 'Open Loon history.',
                            },
                        ],
                        [
                            {
                                type: 'text',
                                text: 'Open the Stripe customer portal to manage your saved payment method and view invoice history.',
                            },
                        ],
                    ],
                },
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'Loon history shows a dated record of every purchase, bonus, achievement reward, and game started, so you can track how your balance changes over time.',
                        },
                    ],
                },
            ],
        },
    ],
});
//# sourceMappingURL=loons.js.map